// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.dep-pattern-list[data-v-01a9bd90]{max-height:240px;overflow:auto;border:1px solid #787b8640;border-radius:4px;padding:4px}.dep-pattern-choice[data-v-01a9bd90]{display:flex;align-items:center;gap:7px;min-height:32px;font-size:12px;cursor:pointer}.dep-pattern-choice svg[data-v-01a9bd90]{flex-shrink:0}.dep-pattern-choice input[data-v-01a9bd90]{flex-shrink:0}\n", ""]);
// Exports
module.exports = exports;
